export const startScoreTypes = {
  OFFICIAL_ACT: "Official ACT",
  PRE_ACT: "Pre-ACT",
  MOCK_ACT: "Mock ACT",
  OTHER: "Other",
};
